import { Box, HStack, setAlpha } from '@talos/kyoko';
import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { mobileButtonBackgroundCSS } from '../../styles';

export const SUB_TAB_BAR_HEIGHT = 36;
export const SUB_TAB_BUTTON_HEIGHT = SUB_TAB_BAR_HEIGHT - 8;

export const SubTabBarWrapper = styled(HStack)`
  height: ${SUB_TAB_BAR_HEIGHT}px;
  padding: ${({ theme }) => theme.spacing4}px;
  border-radius: ${SUB_TAB_BAR_HEIGHT / 2}px;
  position: relative;
  ${mobileButtonBackgroundCSS};
`;

export const SubSelectedIndicatorWrapper = styled(Box)`
  height: ${SUB_TAB_BUTTON_HEIGHT}px;
  border-radius: ${SUB_TAB_BUTTON_HEIGHT / 2}px;
  position: absolute;
  background: ${({ theme }) => setAlpha(0.8, theme.colors.gray['050'])};
  transition: transform 300ms;
  left: ${({ theme }) => theme.spacing4}px;
`;

export const SubTabButtonWrapper = styled(HStack)<{ isSelected?: boolean }>`
  height: ${SUB_TAB_BUTTON_HEIGHT}px;
  border: none;
  position: relative;
  z-index: 1;
  flex: 1;
  min-width: 0;
  border-radius: ${SUB_TAB_BUTTON_HEIGHT / 2}px;
  color: ${({ theme }) => theme.colorTextImportant};
  padding: 0 ${({ theme }) => theme.spacing12}px;
  transition: color 300ms;
  font-size: ${12 / 16}rem;
`;

export const SubTabButtonLabel = styled(Box)`
  display: block;
  min-width: 0;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const subTabButtonResetCSS = css`
  height: ${SUB_TAB_BUTTON_HEIGHT}px;
  min-width: 0;
  padding: 0;
  border: none;
  background: transparent;
  text-decoration: none;
`;

export const SubTabButtonElement = styled.button`
  ${subTabButtonResetCSS};
  flex: 1;
`;

export const SubTabNavLinkElement = styled(NavLink)`
  ${subTabButtonResetCSS};
  flex: 1;
`;

export const SubTabOverflowButtonElement = styled.button`
  ${subTabButtonResetCSS};
  flex: 0 0 auto;
`;
